import { useParams } from "react-router-dom";
import { QuestCompleteView } from "../views/questCompleteView";
import locationTask from "../data/locationTask.json";

function QuestComplete() {
  const { mode, id, questType } = useParams();
  const location = locationTask[id];
  const locationName = location ? location.title : '';

  const imageKey = `drawing_${id}`;

  function getQuestDisplayNameACB(type) {
    switch(type) {
      case 'factFiction':
        return 'Fact or Fiction';
      case 'speechBubble':
        return 'Speech Bubble';
      case 'mindSnap':
        return 'Mind Snap';
      case 'mirrorShot':
        return 'Mirror Shot';
      case 'timelineScramble':
        return 'Timeline Scramble';
      default:
        return 'Quest';
    }
  }

  function goToModeInfoACB() {
    window.location.hash = `#/travelInfo/${id}/${mode}`;
  }

  function goToModeSelectACB(){
    window.location.hash = `#/modeSelection/${id}`
  }

  return (
    <QuestCompleteView
      questDisplayName={getQuestDisplayNameACB(questType)}
      onContinue={goToModeInfoACB}
      onModeSelect={goToModeSelectACB}
      locationName={locationName}
      imageKey={imageKey}
      mode={mode}
    />
  );
}

export { QuestComplete };